import { RouteObject } from "react-router";
import IdKortView from "@/features/idkort/pages/IdKortView";
import { ROUTES } from "@/constants/routes";

export const idkortRoutes: RouteObject[] = [
  {
    id: ROUTES.idkort.id,
    path: "/idkort",
    element: <IdKortView />,
  },
];
